/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable no-console */
import React, { useEffect, useState } from "react";
import { Link, useParams, useNavigate, useLocation } from "react-router-dom";
import Select from "react-select";
import { ViewAdminWrapper } from "../../components/ManageAdmin/style";
import MaterialInput from "../../components/common/UI/MaterialInput";
import {
  Heading,
  TableWarpper,
  Text,
  IconInactive,
  IconView,
  ButtonSolid,
  ButtonOutline,
} from "../../components/styledConstants";
import { isEmpty, getParams, fromDateConvert, toDateConvert, dateConvertWithoutTime } from "../../utils/common";
import Request from "../../utils/Request";
import { vaRetryCreationRequest, vpaRetryCreationRequest } from "../../utils/api";
import Config from "../../utils/config";
import CsvDown from "../../components/ExportFiles/CsvDown";
import IconActive from "../../assets/images/IconActive";
import PdfDown from "../../components/ExportFiles/PdfDown";
import FilterBox from "../../components/common/FilterBox";
import Pagination from "../../components/common/Pagination";
import IconUser from "../../assets/images/IconUser";
import IconEmail from "../../assets/images/IconEmail";
import IconMobile from "../../assets/images/IconMobile";
import IconEdit from "../../assets/images/IconEdit";
import IconRefresh from "../../assets/images/IconRefresh";
import Loader from "../../components/common/Loader";
import TableLoader from "../../components/common/TableLoader";
import ErrorMessage from "../../components/ErrorMessage";
import SuccessMessage from "../../components/SuccessMessage";
import IconDate from "../../assets/images/IconDate";
import { FilterWrapper } from "./style";
import ItemPerPage from "../../components/common/ItemPerPage";
import { BlockPayInWrapper } from "../../components/MerchantDetail/PaymentSettings/style";
import { ConfirmModalWrapper } from "../../components/common/UI/ConfirmationModal/style";

const userStatusColor = {
  active: "color10",
  inactive: "color4",
  suspended: "color11",
};

const statusOptions = [
  { value: "", label: "Select Status" },
  { value: "TRUE", label: "Active" },
  { value: "FALSE", label: "Inactive" },
];
const vpastatusOptions = [
  { value: "true", label: "Active" },
  { value: "false", label: "Inactive" },
];
const mstatusOptions = [
  { value: "ACTIVE", label: "ACTIVE" },
  { value: "UNVERIFIED", label: "UNVERIFIED" },
  { value: "INACTIVE", label: "INACTIVE" },
  { value: "SUSPENDED", label: "SUSPENDED" },
];
const walletOptions = [
  { value: "LOWEST", label: "LOW" },
  { value: "HIGHEST", label: "HIGH" },
];
const categoryOptions = [
  { value: "GOLD", label: "GOLD" },
  { value: "SILVER", label: "SILVER" },
  { value: "PLATINUM", label: "PLATINUM" },
];
const upgradeStatus = [{ value: "ACTIVE", label: "Active" }];
const filterForm = [
  {
    name: "mobileNumber",
    type: "text",
    placeholder: "Mobile Number",
    value: "",
  },
  {
    icon: <IconDate />,
    name: "fromDate",
    value: "",
    className: "item-text pl16",
    dateFormat: "d-MM-yyyy",
    type: "date",
    showMonthDropdown: true,
    showYearDropdown: true,
    yearDropdownItemNumber: 80,
    scrollableYearDropdown: true,
    placeholder: "From Date",
    maxDate: new Date(),
    error: "",
  },
  {
    icon: <IconDate />,
    name: "toDate",
    value: "",
    className: "item-text pl16",
    dateFormat: "d-MM-yyyy",
    type: "date",
    showMonthDropdown: true,
    showYearDropdown: true,
    yearDropdownItemNumber: 80,
    scrollableYearDropdown: true,
    placeholder: "To Date",
    maxDate: new Date(),
    error: "",
  },
  {
    name: "name",
    type: "text",
    placeholder: "Name",
    value: "",
  },
  {
    name: "email",
    type: "text",
    placeholder: "Email",
    value: "",
  },
  {
    name: "orgCode", 
    type: "text",
    placeholder: "Org Code",
    value: "",
  },
  {
    name: "vaFilter",
    value: "",
    type: "select",
    placeholder: "VA Status",
    options: statusOptions,
  },
  // {
  //   name: "walletBalanceFilter",
  //   value: "",
  //   type: "select",
  //   placeholder: "Wallet Balance",
  //   options: walletOptions,
  // },
  // {
  //   name: "userCategory",
  //   value: "",
  //   type: "select",
  //   className: "usercategory",
  //   placeholder: "User Category",
  //   options: categoryOptions,
  // },
  {
    name: "vpaActive",
    value: "",
    type: "select",
    placeholder: "VPA Status",
    options: vpastatusOptions,
  },
  // {
  //   name: "merchantStatus",
  //   value: "",
  //   type: "select",
  //   placeholder: "Status",
  //   options: mstatusOptions,
  // },
  {
    name: "userStatus",
    value: "",
    type: "select",
    placeholder: "User Status",
    options: mstatusOptions,
  },
  {
    name: "upgradeStatus",
    value: "",
    type: "select",
    placeholder: "Upgrade Status",
    options: upgradeStatus,
  },
];

const showagentFilter = {
  icon: <IconUser />,
  name: "showmerchant",
  type: "checkbox",
  value: "",
  placeholder: "Show Merchant",
  className: "merchantcheckbox",
};

const roleConfig = {
  individual: "ROLE_INDIVIDUAL_MERCHANT_USER",
  business: "ROLE_BUSINESS_MERCHANT_USER",
  basic_user: "ROLE_BASIC_USER",
};

export default function BasicUserList() {
  const { usertype: paramUsertype } = useParams();
  const [controls, setControls] = useState([...filterForm]);
  const [userData, setUsers] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const [loader, setLoader] = useState(false);
  const [pageSize, setPageSize] = useState(10);
  const [totalPages, setTotalPages] = useState(1);
  const [downloadPayload, setDownloadPayload] = useState({});
  const [message, setMessage] = useState({ success: "", error: "" });
  const [searchUserList, setSearchUserList] = useState([]);
  const [autoCompleteShow, setAutoCompleteShow] = useState(false);
  const [userDetail, setUserDetails] = useState({});
  const [openModal, setOpenModal] = useState(false);
  const [minkycUserId, setMinkycUserId] = useState();
  const [usertype, setUsertype] = useState(paramUsertype || "basic_user");
  let navigate = useNavigate();
  const location = useLocation();
  const queryparam = location.search.split("=")[1];
  console.log("usertype", usertype);
  useEffect(() => {
    const _controls = [...controls];
    setTimeout(() => {
      _controls[0].value = queryparam;
      setControls(_controls);
    }, 1000);
  }, [queryparam]);

  

  const fetchListData = (userTypeParam, agentId = "") => {
    const userType = roleConfig[userTypeParam];
    console.log("basic user........", Config.apis.admin.MERCHANT_LIST);

    const successHandler = (res) => {
      if (res.data && res.data.content) {
        setUsers(res.data.content);
        setLoader(false);
        setTotalPages(res.data.totalPages);
        const roleMap = {
          ROLE_INDIVIDUAL_MERCHANT_USER: "individual",
          ROLE_BUSINESS_MERCHANT_USER: "business",
          ROLE_BASIC_USER: "basic_user",
        };
        if (res.data.usertype) {
          setUsertype(roleMap[res.data.usertype] || usertype);
        }
        const params = getParams(controls);
        console.log("upgrade status", params?.upgradeStatus?.value);
        // params.userType = "ROLE_INDIVIDUAL_MERCHANT_USER";
        params.pagination = {
          pageNo: currentPage,
          pageSize: res.data.totalElements ? res.data.totalElements : 10,
        };
        params.flag = "minkyc";
        params.businessCat="BASIC_USER";
        if (params?.vaFilter?.value) {
          params.vaFilter = params.vaFilter.value;
        }
        if (params.vaFilter === "") {
          params.vaFilter = "ALL";
        }
        if (params?.walletBalanceFilter?.value) {
          params.walletBalanceFilter = params.walletBalanceFilter.value;
        }
        if (params?.userStatus?.value) {
          params.status = params.userStatus.value;
        }
        if (params?.merchantStatus?.value) {
          params.merchantStatus = params.merchantStatus.value;
        }
        // if (params?.userCategory?.value) {
        //   params.userCategory = params.userCategory.value;
        // } else {
        //   params.userCategory = "BASIC";
        // }
        if (params?.vpaActive?.value) {
          params.vpaActive = params.vpaActive.value;
        } else {
          params.vpaActive = null;
        }
        if (params?.upgradeStatus?.value) {
          params.upgradeStatus = params?.upgradeStatus?.value;
        } else {
          params.upgradeStatus = null;
        }
        if (params?.fromDate) {
          params.fromDate = params.fromDate ? dateConvertWithoutTime(fromDateConvert(params.fromDate)) : null;
        }
        if (params?.toDate) {
          params.toDate = params.fromDate ? dateConvertWithoutTime(toDateConvert(params.toDate)) : null;
        }
        if (params.showmerchant && params.agentName !== "") {
          params["referredBy"] = userDetail?.id;
        }
        if (agentId) {
          params["referredBy"] = agentId;
        }
        if (params.agentName && !params.showmerchant) {
          params["name"] = params.agentName;
        }
        const downloadParam = params;
        downloadParam.pagination.pageNo = 1;
        setDownloadPayload(params);
      }
    };
    const errorHandler = () => { };
    const api = new Request("", successHandler, errorHandler, false);
    const params = getParams(controls);
    // params.userType = userType || "ROLE_INDIVIDUAL_MERCHANT_USER";
    params.pagination = {
      pageNo: currentPage,
      pageSize: pageSize,
    };
    params.flag = "minkyc";
    params.businessCat="BASIC_USER"
    if (params?.vaFilter?.value) {
      params.vaFilter = params.vaFilter.value;
    }
    if (params?.userStatus?.value) {
      params.status = params.userStatus.value;
    }
    if (params?.walletBalanceFilter?.value) {
      params.walletBalanceFilter = params.walletBalanceFilter.value;
    }
    if (params?.merchantStatus?.value) {
      params.merchantStatus = params.merchantStatus.value;
    }
    // if (params?.userCategory?.value) {
    //   params.userCategory = params.userCategory.value;
    // } else {
    //   params.userCategory = "BASIC";
    // }
    if (params?.vpaActive?.value) {
      params.vpaActive = params.vpaActive.value;
    } else {
      params.vpaActive = null;
    }
    if (params?.upgradeStatus?.value) {
      params.upgradeStatus = params?.upgradeStatus?.value;
    } else {
      params.upgradeStatus = null;
    }
    // if (params?.fromDate) {
    //   params.fromDate = params.fromDate ? dateConvertWithoutTime(fromDateConvert(params.fromDate)) : null;
    // }
    // if (params?.toDate) {
    //   params.toDate = params.fromDate ? dateConvertWithoutTime(toDateConvert(params.toDate)) : null;
    // }
    if (params.showmerchant && params.agentName !== "") {
      params["referredBy"] = userDetail?.id;
    }
    if (agentId) {
      params["referredBy"] = agentId;
    }
    if (params.agentName && !params.showmerchant) {
      params["name"] = params.agentName;
    }
    if (params.vaFilter === "") {
      params.vaFilter = "ALL";
    }
    console.log("params", params);
    if (params?.fromDate) {
      params.fromDate = params.fromDate ? dateConvertWithoutTime(fromDateConvert(params.fromDate)) : null;
    }
    if (params?.toDate) {
      params.toDate = params.fromDate ? dateConvertWithoutTime(toDateConvert(params.toDate)) : null;
    }
    if (queryparam) {
      params.mobileNumber = queryparam;
    }
    const downloadParam = params;
    downloadParam.pagination.pageNo = currentPage;
    setDownloadPayload(params);
    return api.post(Config.apis.admin.BASIC_USER_LIST, params);
  };

  useEffect(() => {
    refreshPage();
  }, [usertype, pageSize]);

  useEffect(() => {
    const query = new URLSearchParams(window.location.search);
    const fromDate = query.get("fromDate");
    const toDate = query.get("toDate");
    const status = query.get("status");
    const agentId = query.get("agentid");
    const _controls = [...controls];
    if (fromDate && toDate) {
      _controls[1].value = new Date(fromDate);
      _controls[2].value = new Date(toDate);
    }
    if (status) {
      const statusData = mstatusOptions.find((option) => option.value === status) || { value: status, label: status };
      _controls[7].value = statusData;
    }
    setControls([..._controls]);
    if (agentId) {
      fetchListData(usertype, agentId);
    } else {
      fetchListData(usertype);
    }
  }, [currentPage, usertype, pageSize]);

  const FilterChangeHandler = (event, index) => {
    const _controls = [...controls];
    const re = /^[0-9\b]+$/;
    const onlyAlphabets = /^[A-Za-z\s]*$/;
    if (event?.target?.name == "mobileNumber") {
      if (event.target.value.length > 10) return;
      if (event.target.value === "" || re.test(event.target.value)) {
        _controls[index].value = event.target.value;
        setControls(_controls);
      }
    } else if (event?.target?.name == "name" || event?.target?.name == "agentName") {
      if (event.target.value === "" || onlyAlphabets.test(event.target.value)) {
        _controls[index].value = event.target.value;
        setControls(_controls);
      }
    } 
    else if (event?.target?.name === "orgCode") {
    _controls[index].value = event.target.value;
    setControls(_controls);
    } else if (event?.target?.name === "showmerchant") {
      if (event?.target?.checked) {
        _controls[index].value = 1;
      } else {
        _controls[index].value = 0;
      }
      setControls(_controls);
    } else {
      if (index === 5) {
        _controls[index].value = !event.value ? "ALL" : event;
      } else {
        _controls[index].value =
          event instanceof Date || (event && event.label) ? event : event ? event.target.value : event;
        if (_controls[index].name === "fromDate") {
          _controls[2].minDate = new Date(_controls[index].value);
          _controls[2].value = "";
        }
        _controls[index].error = "";
      }
      setControls(_controls);
    }
  };

  const searchAdmin = (event) => {
    event.preventDefault();
    setCurrentPage(1);
    const params = getParams(controls);
    console.log("params", params);
    const _controls = [...controls];
    if ((params.toDate === "" || params.toDate === null) && params.fromDate !== "" && params.fromDate !== null) {
      _controls[2].error = "Please select to date";
    } else if (params.toDate !== "" && params.toDate !== null && (params.fromDate === "" || params.fromDate === null)) {
      _controls[1].error = "Please select from date";
    } else {
      _controls[2].error = "";
      _controls[1].error = "";
      setControls([..._controls]);
      fetchListData(usertype);
    }
    setControls([..._controls]);
  };

  const manageStatus = (params) => {
    const successHandler = (res) => { };
    const errorHandler = (res) => { };
    setMessage({ success: "", error: "" });
    const api = new Request("", successHandler, errorHandler, false);
    return api.get(`${Config.apis.admin.UPDATE_STATUS}?id=${params.id}&status=${params.status}`).then((res) => {
      console.log("response", res);
      if (res.data.message) {
        if (res.data.message == "SUCCESS") {
          setMessage({ success: "STATUS UPDATED SUCCESSFULLY" });
        } else {
          setMessage({ error: res?.data?.message });
        }
      }
      if (res.status) {
        fetchListData(usertype);
      }
    });
  };

  console.log("messfage", message.success);
  const onRetryVACreation = (params) => {
    vaRetryCreationRequest(params).then((res) => {
      if (res?.data?.code === "0000") {
        fetchListData(usertype);
      }
    });
  };

  const onRetryVPACreation = (userId) => {
    vpaRetryCreationRequest(userId).then((res) => {
      if (res?.data?.code === "0000") {
        fetchListData(usertype);
      } else {
        setMessage({ success: "", error: res?.data?.msg });
        clearMessage();
      }
    });
  };

  const nextPageHandler = (curpage) => {
    setLoader(true);
    setCurrentPage(curpage);
  };

  const headers = [
    { label: "Id", key: "id" },
    { label: "Name", key: "name" },
    { label: "Email Id", key: "email" },
    { label: "Agent Name", key: "agentName" },
    { label: "Distributor Name", key: "distributorName" },
    { label: "Registered On", key: "createdAt" },
    { label: "Mobile No.", key: "mobileNo" },
    { label: "Address", key: "address" },
    { label: "Plan", key: "userCategory" },
    { label: "Vpa Id", key: "vpaId" },
    { label: "User Role", key: "businessCatg" },
    { label: "Wallet Balance", key: "walletBalance" },
    { label: "Status", key: "status" },
    { label: "VA Status", key: "vaStatus" },
    { label: "VPA Status", key: "vpaStatus" },
    { label: "Kyc Status", key: "kycStatus" },
    { label: "Org Code", key: "orgCode" },

  ];

  const tableHeader = [
    {
      name: "Name",
      email: "Email",
      mobile: "Mobile No.",
      createdAt: "Registered On",
      status: "Status",
      vpaId: "VPA Id",
      vaStatus: "VA Status",
      kycStatus:"Kyc Status"
    },
  ];

  const getTableBody = (data) => {
    const tableBody = [];
    data.forEach((element) => {
      const walletBalance = element?.walletBalance ? parseFloat(element?.walletBalance).toFixed(2) : "0";
      tableBody.push({
        name: element?.name,
        email: element?.email,
        mobile: element?.mobileNo,
        createdAt: element?.createdAt.split("T")[0] + " " + element.createdAt?.split("T")[1]?.split(".")?.[0],
        wallet: "Rs. " + walletBalance,
        status: element?.status,
        vpaId: element?.vpaId,
        vaStatus: element?.vaStatus ? "Active" : "Inactive",
        kycStatus: element?.kycStatus || "-",
      });
    });
    return tableBody;
  };

  const vpaHeaders = [
    { label: "Merchant Name", key: "businessName" },
    { label: "Merchant Address 1", key: "merchantAddressOne" },
    { label: "Merchant Address 2", key: "merchantAddressTwo" },
    { label: "Merchant State", key: "merchantState" },
    { label: "Merchant Postal Code", key: "merchantPostalCode" },
    { label: "Merchant Phone Number", key: "merchantPhoneNumber" },
    { label: "Merchant Mobile Number", key: "merchantMobileNumber" },
    { label: "Merchant Contact Name", key: "businessName" },
    { label: "Merchant Contact Address 1", key: "merchantContactAddressOne" },
    { label: "Merchant Contact Address 2", key: "merchantContactAddressTwo" },
    { label: "Merchant Contact State", key: "merchantContactState" },
    { label: "Merchant Contact PostalCode", key: "merchantContactPostalCode" },
    { label: "Merchant Contact Phone", key: "merchantContactPhone" },
    { label: "Merchant MCC No", key: "merchantMCCNo" },
    { label: "Credit Account No", key: "creditAccountNo" },
    { label: "Credit IFSC Code", key: "creditIfscCode" },
    { label: "VPA", key: "vpa" },
  ];

  const options = [
    { label: "Active", value: "ACTIVE" },
    { label: "Suspended", value: "SUSPENDED" },
    { label: "Inactive", value: "IN_ACTIVE" },
    { label: "Verified", value: "ACTIVE" },
  ];

  const apiParams = {
    name: "",
    email: "",
    mobileNumber: "",
    userType: roleConfig[usertype],
    pagination: {
      pageNo: 1,
      pageSize: 100,
    },
    vaFilter: "ALL",
  };

  const apiPramsVPA = {
    userType: roleConfig[usertype],
    pagination: {
      pageNo: 1,
      pageSize: 100,
    },
    record: "ALL",
    vaFilter: "ALL",
    vpaActive: false,
  };

  const clearMessage = () => {
    setTimeout(() => {
      setMessage({ success: "", error: "" });
    }, 3000);
  };

  const resetFilter = () => {
    for (let i = 0; i < filterForm.length; i++) {
      if (filterForm[i].name === "vaFilter") {
        filterForm[i].value = "";
      } else {
        filterForm[i].value = "";
      }
    }
  };

  const refreshPage = () => {
    setUserDetails({});
    if (filterForm.length === 13) {
      filterForm.pop();
      const _controls = [...controls];
      _controls.pop();
      setControls(_controls);
    }
    resetFilter();
    setCurrentPage(1);
    if (currentPage == 1) {
      // fetchListData(usertype);
    }
  };

  const searchUsers = (name) => {
    if (name.length < 3) {
      setSearchUserList([]);
      if (filterForm?.length === 13) {
        filterForm.pop();
        const _controls = [...controls];
        _controls.pop();
        setControls(_controls);
      }
      return;
    }
    const successHandler = (res) => {
      if (res?.data && res?.data?.content) {
        setSearchUserList(res.data.content);
      } else {
        setSearchUserList([]);
        if (filterForm?.length === 13) {
          filterForm.pop();
          const _controls = [...controls];
          _controls.pop();
          setControls(_controls);
        }
      }
    };
    const errorHandler = () => { };
    const api = new Request("", successHandler, errorHandler, false);
    const payload = {
      vaFilter: "ALL",
      name: name,
      userType: "ROLE_AGENT",
      pagination: {
        pageNo: 1,
        pageSize: 100,
      },
    };
    setAutoCompleteShow(true);
    return api.post(`${Config.apis.admin.BASIC_USER_LIST}`, payload);
  };

  const setUserDetail = (item) => {
    setUserDetails(item);
    setAutoCompleteShow(false);
    const _controls = [...controls];
    _controls[11].value = item.name;
    _controls.push(showagentFilter);
    filterForm.push(showagentFilter);
    setControls(_controls);
  };

  const renderStatus = (data) => {
    const status = data?.toLowerCase();
    switch (status) {
      case "active":
        return (
          <div className="flex flex-center">
            <IconActive width="13" className="align-top mr6" color="#2AC940" />
            <Text size="xsm" fw="medium" color="color10">
              {data}
            </Text>
          </div>
        );
      case "inactive":
        console.log("inactive");
        return (
          <div className="flex flex-center">
            <IconInactive width="12px" className="align-top mr6" />
            <Text size="xsm" fw="medium" color="color4">
              {data}
            </Text>
          </div>
        );
      case "unverified":
        return (
          <div className="flex flex-center">
            <IconInactive width="12px" className="align-top mr6" />
            <Text size="xsm" fw="medium" color="color4">
              {data}
            </Text>
          </div>
        );
      case "suspended":
        return (
          <div className="flex flex-center">
            <IconInactive width="12px" className="align-top mr6" color="color11" />
            <Text size="xsm" fw="medium" color="color11">
              {data}
            </Text>
          </div>
        );
    }
  };

  const cashBackUser = (value) => {
    const successHandler = (res) => {
      console.log(".....", res);
      if (res) {
        if (res?.message == "SUCCESS") {
          setMessage({ success: "CASHBACK STATUS UPDATED SUCCESSFULLY" });
          fetchListData(usertype);
        } else {
          console.log("hello", res?.msg);
          setMessage({ error: res?.msg });
        }
      }
    };
    const errorHandler = () => { };
    const api = new Request("", successHandler, errorHandler, false);
    let payload = {};
    if (value.status === "UNVERIFIED" || value.status === "INACTIVE") {
      payload = {
        userId: value?.id,
        status: "INACTIVE",
      };
    } else if (value.cashBackStatus === "ACTIVE") {
      payload = {
        userId: value?.id,
        status: "INACTIVE",
      };
    } else if (value.cashBackStatus === "INACTIVE") {
      payload = {
        userId: value?.id,
        status: "ACTIVE",
      };
    }
    return api.post(`${Config.apis.admin.CASH_BACK}`, payload);
  };

  const handleUpgrade = (id) => {
    setOpenModal(true);
    setMinkycUserId(id);
  };

  const handleConfirm = () => {
    const successHandler = (res) => {
      if (res) {
        if (res?.message == "SUCCESS") {
          setMessage({ success: "Min KYC User Updated Succesfully" });
          setOpenModal(false);
          fetchListData(usertype);
        }
      }
    };
    const errorHandler = () => { };
    const api = new Request("", successHandler, errorHandler, false);
    return api.get(`${Config.apis.user.UPGRADE_MIN_KYC}/${minkycUserId}`);
  };

  const handleCancel = () => {
    setOpenModal(false);
  };
  console.log("userData", usertype);

  return (
    <>
      <div className="flex flex-center space-between mb10">
        <Heading size="xxl" color="color7">
          Min Kyc User
        </Heading>
        <div className="flex flex-center">
          <div className="mr20">
            <CsvDown
              headers={headers}
              url={`${Config.apis.admin.BASIC_USER_LIST}`}
              params={downloadPayload}
              title="CSV"
            />
          </div>
          <div>
            <PdfDown
              heading="Merchant Details."
              tableHeader={tableHeader}
              getTableBody={getTableBody}
              url={Config.apis.admin.BASIC_USER_LIST}
              params={downloadPayload}
            />
          </div>
        </div>
      </div>
      <ViewAdminWrapper>
        <FilterWrapper>
          <FilterBox
            filterForm={controls}
            onFilterChange={FilterChangeHandler}
            onFilterSubmit={searchAdmin}
            refreshPage={refreshPage}
            className="transactionfilter"
          />
          {autoCompleteShow && searchUserList.length ? (
            <div className="agentlist">
              <ul>
                {searchUserList?.length
                  ? searchUserList?.map((item, index) => (
                    <li key={"srch" + index}>
                      <Text
                        onClick={() => {
                          setUserDetail(item);
                        }}
                        role="button"
                        tabIndex="0"
                        style={{ cursor: "pointer" }}
                      >
                        {item?.name}
                      </Text>
                    </li>
                  ))
                  : ""}
              </ul>
            </div>
          ) : (
            ""
          )}
        </FilterWrapper>
        {message.error && (
          <>
            {" "}
            <ErrorMessage error={message.error} /> <br />
          </>
        )}
        {message.success && (
          <>
            <SuccessMessage successMessage={message.success} />
          </>
        )}
        {!userData ? (
          <div className="table-loader-wrapper animatedBackground mt24"></div>
        ) : (
          <TableWarpper className="mt24">
            <table className="table">
              <thead>
                <tr>
                  <th className="text-left">
                    <Text size="rg" color="color7" fw="medium">
                      Name
                    </Text>
                  </th>
                  <th className="text-left">
                    <Text size="rg" color="color7" fw="medium">
                      Email
                    </Text>
                  </th>
                  <th className="text-left">
                    <Text size="rg" color="color7" fw="medium">
                      Name on Aadhar
                    </Text>
                  </th>
                  <th className="text-left">
                    <Text size="rg" color="color7" fw="medium">
                      Contact
                    </Text>
                  </th>
                  {usertype !== "business" ? (
                    <th className="text-left">
                      <Text size="rg" color="color7" fw="medium">
                        Plan
                      </Text>
                    </th>
                  ) : (
                    ""
                  )}
                  {usertype !== "business" ? (
                    <th className="text-left">
                      <Text size="rg" color="color7" fw="medium">
                        Distributor Name
                      </Text>
                    </th>
                  ) : (
                    ""
                  )}
                  <th className="text-left">
                    <Text size="rg" color="color7" fw="medium">
                      Registered on
                    </Text>
                  </th>
                  <th className="text-left">
                    <Text size="rg" color="color7" fw="medium">
                      Status
                    </Text>
                  </th>
                  {usertype !== "business" ? (
                    <th className="text-left">
                      <Text size="rg" color="color7" fw="medium">
                        VPA Id
                      </Text>
                    </th>
                  ) : (
                    ""
                  )}
                  {usertype !== "business" ? (
                    <th className="text-left">
                      <Text size="rg" color="color7" fw="medium">
                        VPA Status
                      </Text>
                    </th>
                  ) : (
                    ""
                  )}
                  <th className="text-left">
                    <Text size="rg" color="color7" fw="medium">
                      CASH Back
                    </Text>
                  </th>
                  <th className="text-left">
                    <Text size="rg" color="color7" fw="medium">
                      VA Status
                    </Text>
                  </th>
                  <th className="text-left">
                    <Text size="rg" color="color7" fw="medium">
                      Kyc Status
                    </Text>
                  </th>
                   <th className="text-left">
                      <Text size="rg" color="color7" fw="medium">
                        Org Code
                      </Text>
                     </th>
                     <th className="text-left">
                      <Text size="rg" color="color7" fw="medium">
                        Risk Category
                      </Text>
                     </th>
                  <th className="text-left">
                    <Text size="rg" color="color7" fw="medium">
                      Action
                    </Text>
                  </th>
                  <th className="text-left">
                    <Text size="rg" color="color7" fw="medium">
                      Upgrade
                    </Text>
                  </th>
                </tr>
              </thead>
              <tbody>
                {loader ? <TableLoader /> : ""}
                {!loader && userData.length ? (
                  userData?.map((user, index) => (
                    <tr key={index}>
                      <td>
                        <Text size="xsm" color="#828282">
                          {user?.name || "-"}
                        </Text>
                      </td>
                      <td>
                        <Text size="xsm" color="#828282">
                          {user?.email || "-"}
                        </Text>
                      </td>
                      <td>
                        <Text size="xsm" color="#828282">
                          {user?.nameOnAadhaar || "-"}
                        </Text>
                      </td>
                      <td>
                        <Text size="xsm" color="#828282">
                          {user?.mobileNo || "-"}
                        </Text>
                      </td>
                      {usertype !== "business" ? (
                        <td>
                          <Text size="xsm" color="#828282">
                            {user?.userCategory || "-"}
                          </Text>
                        </td>
                      ) : (
                        ""
                      )}
                      {usertype !== "business" ? (
                        <td>
                          <Text size="xsm" color="#828282">
                            {user?.distributorName || "-"}
                          </Text>
                        </td>
                      ) : (
                        ""
                      )}
                      <td>
                        <Text size="xsm" color="#828282">
                          {user?.createdAt?.split("T")[0] + " " + user?.createdAt?.split("T")[1]?.split(".")?.[0] ||
                            "-"}
                        </Text>
                      </td>
                      <td>{renderStatus(user?.status)}</td>
                      {usertype !== "business" ? (
                        <td>
                          <Text size="xsm" fw="medium" color="#828282">
                            {user?.vpaId || "-"}
                          </Text>
                        </td>
                      ) : (
                        ""
                      )}
                      {usertype !== "business" ? (
                        <td>
                          <Text size="xsm" fw="medium" color={user?.vpaStatus ? "color10" : "color3"}>
                            {user?.vpaStatus ? "ACTIVE" : "INACTIVE"}
                          </Text>
                        </td>
                      ) : (
                        ""
                      )}
                      <td>
                        <BlockPayInWrapper>
                          <div
                            className="toggle-with-label flex flex-center space-between"
                            style={{ padding: 0, margin: 0, height: "17px", marginLeft: "5px", width: "40px" }}
                          >
                            <label className="switch">
                              <input
                                type="checkbox"
                                checked={user.cashBackStatus === "ACTIVE" && user.status.toLowerCase() === "active"}
                                onClick={() => cashBackUser(user)}
                                disabled={
                                  user?.status?.toLowerCase() === "unverified" ||
                                  user?.status?.toLowerCase() === "unverified"
                                }
                              />
                              <span className="slider round"></span>
                            </label>
                          </div>
                        </BlockPayInWrapper>
                      </td>
                      <td>
                        {user?.vaStatus ? (
                          <div className="flex flex-center">
                            <IconActive width="13" className="align-top mr6" color="#2AC940" />
                            <Text size="xsm" fw="medium" color="color10">
                              ACTIVE
                            </Text>
                          </div>
                        ) : (
                          <div className="flex flex-center">
                            <IconInactive width="12px" className="align-top mr6" />
                            <Text size="xsm" fw="medium" color="color4">
                              INACTIVE
                            </Text>
                          </div>
                        )}
                      </td>
                      <td>{renderStatus(user?.kycStatus)}</td>
                      <td>
                        <Text size="xsm" color="#828282">
                          {user?.orgCode || "-"}
                        </Text>
                       </td>
                       <td>
                        <Text size="xsm" color="#828282" style={{ textTransform: "uppercase" }}>
                          {user?.riskCategory || "-"}
                        </Text>
                       </td>
                      <td>
                        <div className="flex flex-center gap24">
                          <div className="change-status-actions pos-rel">
                            <IconActive className="align-top" color="#2AC940" />
                            <div className="tooltip">
                              <ul>
                                <li
                                  className="pointer flex flex-center"
                                  onClick={() => manageStatus({ id: user?.id, status: "SUSPENDED" })}
                                >
                                  <IconInactive width="12px" className="align-top mr6" color="color11" />
                                  <Text size="xxxsm" color="color3">
                                    Suspended
                                  </Text>
                                </li>
                                <li
                                  className="pointer flex flex-center"
                                  onClick={() => manageStatus({ id: user?.id, status: "VERIFIED" })}
                                >
                                  <IconActive width="13" className="align-top mr6" color="#2AC940" />
                                  <Text size="xxxsm" color="color3">
                                    Verified
                                  </Text>
                                </li>
                                <li
                                  className="pointer flex flex-center"
                                  onClick={() => manageStatus({ id: user?.id, status: "UNVERIFIED" })}
                                >
                                  <IconInactive width="12px" className="align-top mr6" color="color11" />
                                  <Text size="xxxsm" color="color3">
                                    UnVerified
                                  </Text>
                                </li>
                              </ul>
                            </div>
                          </div>
                          <Link to={`/merchant-detail/${user?.id}/${usertype}`}>
                            <IconView />
                          </Link>
                          </div>
                      </td>
                      {user.upgradeStatus === "ACTIVE" ? (
                        <td>
                          <ButtonSolid width="120px" onClick={() => handleUpgrade(user?.id)} primary xl>
                            Upgrade
                          </ButtonSolid>
                        </td>
                      ) : (
                        ""
                      )}
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colSpan="12" style={{ textAlign: "center" }}>
                      No record found
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </TableWarpper>
        )}
        <div className="mt24 flex flex-center">
          {userData.length > 1 && (
            <ItemPerPage
              pageSize={pageSize}
              getPageSize={(pagesize) => {
                setPageSize(pagesize);
              }}
            />
          )}
          {totalPages > 1 && (
            <Pagination
              totalPages={totalPages}
              currentPage={currentPage}
              getCurrentPageData={(curpage) => {
                setCurrentPage(curpage);
              }}
            />
          )}
        </div>
      </ViewAdminWrapper>
      {openModal ? (
        <ConfirmModalWrapper>
          <div className="modal-content">
            <Text size="lg" color="color3" className="mb30">
              Are you sure you want to Upgrade the user?
            </Text>
            <div className="actions mt30">
              <ButtonOutline className="mr12" primary rg onClick={handleCancel}>
                {"Cancel"}
              </ButtonOutline>
              <ButtonSolid primary rg onClick={handleConfirm}>
                {"Confirm"}
              </ButtonSolid>
            </div>
          </div>
        </ConfirmModalWrapper>
      ) : (
        ""
      )}
    </>
  );
}